import React, { useRef, useEffect, useState} from 'react';
import Card from '@material-ui/core/Card';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import API_PATH from "../../../constants/config.json";
import Cookies from 'js-cookie';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { makeStyles } from '@material-ui/core/styles';
import { isLogin } from '../../../functions/Auth';
const API_URL = process.env.REACT_APP_BASE_URL;
const axios = require('axios');

let timePeriod = undefined;
const SignalPlanningCard = props => { 
    const [capacityRatioCat, setCapacityRatioCat] = useState([]);
    const [scenariosList, setScenariosList] = useState([]);
    
    const [dateCount, setdateCount] = useState(null);   
    const [period, setPeriod] = useState(null);   
    const [florRatio, setFlorRatio] = useState(null);       
    const [moreOpt, setMoreOpt] = useState(false);

    useEffect(()=>{
        timePeriod = props.timePeriod;
    },[props.timePeriod]);

    useEffect(()=>{
        getCapacityRatio();
        getScenarioList(props.station_id);
    }, [props.toggleMarkerCapacitySelected]);

    useEffect(() => {
        if(props.scenario !== undefined) {                    
            getCapacityRatio();            
        }
    }, [props.scenario]);

    useEffect(() => {
        if(props.station_id) {                    
            getScenarioList(props.station_id);            
        }
        /* if(props.critical_flow_ratio && !florRatio){
            setFlorRatio(props.critical_flow_ratio);    
        } */
    }, [props.station_id]);    

    const getScenarioList = (station) =>{
        try {
            axios({
                method: 'post',
                headers: {
                    'payload': Cookies.get('payload'),
                },
                data: {
                    "stationId":station
                },
                url: API_URL + API_PATH.getScenarioList,
            })
            .then(async function (response) {
                if (response && response.status == '200') {
                    if(response.data.data) {
                        let data = response.data.data;     
                        let mapped = data.map((item, index)=>{
                            return {index : index, isGlobal:item.isGlobal, id:item.scenario_id }
                        });
                        mapped.sort((a, b)=>(
                            b.isGlobal - a.isGlobal || b.id - a.id
                        ));
                        let dataSorted = mapped.map((e)=>{return data[e.index]});
                        let defaultScenario = getDefaultGlobalScenario(dataSorted, timePeriod);
                        if (defaultScenario !== undefined){
                            props.setActiveFromCard(defaultScenario.scenario_id);    
                            setdateCount(defaultScenario.date_count);
                            setPeriod(defaultScenario.period);
                            setFlorRatio(defaultScenario.critical_flow_ratio);
                        } else{
                            props.setActiveFromCard(dataSorted[0].scenario_id);
                            setdateCount(dataSorted[0].date_count);
                            setPeriod(dataSorted[0].period);
                            setFlorRatio(dataSorted[0].critical_flow_ratio);
                        }                        
                        setScenariosList(dataSorted);
                    }
                }                            
            })
            .catch((err) => {
                console.error(err);                        
            })
        } catch (error) {
            console.error(error);            
        }
    }

    const getDefaultGlobalScenario=(scenarios, period)=>{   
        return scenarios.find(scenario => scenario.period == period); //props.toggleMarkerCapacitySelected isn't string
    }

    const getCapacityRatio = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getCapacityRatio,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        if(response.data.data)
                            setCapacityRatioCat(response.data.data);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {
            console.error(error);
        }
    }
    const handleChangeActiveScenario = (e) => {
        let scenarioID = e.target.value;
        scenariosList.forEach(scenario => {
            if(scenario.scenario_id == scenarioID){
                setdateCount(scenario.date_count);
                setPeriod(scenario.period);
                setFlorRatio(scenario.critical_flow_ratio);
            }
         }); 
        props.setActiveFromCard(scenarioID);
    }

    const handleClickAway = () => {
        setMoreOpt(false);
    }


    const getSelectStyle= makeStyles({
        height:{
            height: (scenariosList.length >= 5) ? '200px' : 'auto'
        }
    });
    
    const clasess_heigh = getSelectStyle();

    return (
        <Card className={'details-main-info signal-planning-details'} style={{position: 'relative'}}>
            <div className="main-summary">
                <div className='lane-status'>                  
                {
                    capacityRatioCat.map(function(it, ind){//
                        if( (florRatio >= it['min'] && florRatio < it['max']) || (!it['max'] && florRatio >= it['min'])) {
                            return <div className={ind===0 ? 'capacity-ratio emerald-txt' : ind===1 ? 'capacity-ratio amber-txt' : 'capacity-ratio red-txt'}>
                                <label className='indicator'></label>
                                <label>{it['capacity']}</label>
                            </div>
                        }
                    })
                }   
                {
                    isLogin() ? <img src={require('../../../assets/icons/lane_config/vertical_dots.svg')} onClick={() => setMoreOpt(!moreOpt)} /> : null
                }
                </div>                               
                <div className='scenario-list'>
                    <label>Avaliable scenarios</label>
                </div>         
                <div className='scenario-list'>
                    <Select                  
                        className="select-dp slc-time-perido-details"                                     
                        value={props.activeFromCard}
                        height='24px'                               
                        onChange={handleChangeActiveScenario}
                        IconComponent={ExpandMoreIcon}
                        MenuProps={{PaperProps:{className:`slct-details-cmp ${clasess_heigh.height}`}}}
                    >                              
                    {
                        scenariosList.map((val, index) => {
                            return <MenuItem value={val.scenario_id}>{val.name}</MenuItem>                        
                        })
                    }                                    
                    </Select>
                </div>
                <div className='scenario-summary'>                                      
                    <div>
                        <label className='light-small-lbl'>Count Date</label>
                        <label className='dark-small-lbl'>{(dateCount)?dateCount : props.date_count}</label>
                    </div>
                    <div>
                        <label className='light-small-lbl'>Period</label>
                        <label className='dark-small-lbl'>{(period)?period : props.period}</label>
                    </div>
                    <div>
                        <label className='light-small-lbl'>Critical flow ratio</label>
                        <label className='dark-small-lbl'>{(florRatio)?florRatio : props.critical_flow_ratio}</label>
                    </div>                    
                </div>
                {
                moreOpt &&
                <ClickAwayListener onClickAway={handleClickAway}>
                    <div className='set-edit-lane'>
                        <div onClick={props.handleOpenAllDetailsSignalPlanning}>
                            <img src={require("../../../assets/icons/external_link.svg")} />
                            <label>View scenario</label>
                        </div>
                    </div>
                </ClickAwayListener>
            }
            </div>            
        </Card>
    )
}

export default SignalPlanningCard;